module.exports = __webpack_public_path__ + "src/img/disk.2f8b28df.png";